<template>
  <div class="mt-1">
    <span class="px-0" v-if="isPrivate">
      <i class="fas fa-lock" style="color: goldenrod"></i>
    </span>
    <span :style="starStyle(1)">
      <i class="fas fa-star"></i>
    </span>
    <span :style="starStyle(2)">
      <i class="fas fa-star"></i>
    </span>
    <span :style="starStyle(3)">
      <i class="fas fa-star"></i>
    </span>
    <span :style="starStyle(4)">
      <i class="fas fa-star"></i>
    </span>
    <span :style="starStyle(5)">
      <i class="fas fa-star"></i>
    </span>
  </div>
</template>

<script>
export default {
  props: ['value', 'isPrivate'],
  methods: {
    starStyle(value) {
      return {
        'padding-left': '0px',
        'padding-right': '0px',
        color: value <= this.value ? 'tomato' : 'gray'
      }
    }
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
